import React, { useState, useEffect } from 'react'
import useAxios from 'axios-hooks'
import { getAuthHeader } from 'utils/auth'
import { Form } from 'antd'
import { PageAlert, notificationToast } from 'components'
import AccountSettingsTop from 'views/Administration/Account/Settings/AccountSettingsTop'
import SettingsForm from 'views/Administration/Account/Settings/SettingsForm'

const formKeys = {
  MAX_PAGES: 'max_pages_per_scan',
  MAX_STEPS: 'max_steps_per_scan',
  PRIORITY: 'priority'
}

const AccountSettings = ({ form, name, id }) => {
  const [limitsData, setLimitsData] = useState({})

  // limits data
  const [{ data: limitsResponse, loading: limitsLoading, error: limitsError }, getLimits] = useAxios({
    url: `/administration/account/${id}/limits`,
    method: 'GET',
    headers: getAuthHeader(),
    validateStatus: false
  })

  // UPDATE limits
  let [{ data: updateLimitsData, loading: updatingLimits, error: updateLimitsError }, updateLimits] = useAxios(
    {
      url: `/administration/account/limits`,
      method: 'POST',
      headers: getAuthHeader(),
      validateStatus: false
    },
    { manual: true }
  )

  const openNotification = (message, errors) => {
    if (!errors) {
      notificationToast({
        message: 'Success',
        description: message,
        icontype: 'check'
      })
    } else {
      notificationToast({
        message: 'Error',
        description: `${message} ${errors.join()}`,
        icontype: 'close-circle'
      })
    }
  }

  const onAfterUpdate = () => {
    form.resetFields()
  }

  // update limits
  const update = () => {
    form.validateFields((errors, values) => {
      if (!errors) {
        updateLimits({
          data: {
            account_id: id,
            max_pages_per_scan: values[formKeys.MAX_PAGES],
            max_steps_per_scan: values[formKeys.MAX_STEPS],
            priority: values[formKeys.PRIORITY]
          }
        })
      }
    })
  }

  // for limits data
  useEffect(() => {
    if (limitsResponse) {
      setLimitsData(limitsResponse)
    }
  }, [limitsResponse])

  // for update limits
  useEffect(() => {
    if (updateLimitsData) {
      if (updateLimitsData.Errors) {
        const errorMessage = updateLimitsData.Errors
        openNotification('Could not update settings.', errorMessage)
      } else {
        openNotification('Settings were updated successfully.')
        getLimits()
      }
    } else if (updateLimitsError) {
      const errorMessage = updateLimitsError?.response?.data?.Errors
      openNotification('Could not create domain.', errorMessage)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateLimitsData, updateLimitsError, getLimits])

  return (
    <>
      {limitsError && <PageAlert message={limitsError} />}
      <AccountSettingsTop accountName={name} />
      <SettingsForm form={form} formKeys={formKeys} data={limitsData} onSubmit={update} loading={updatingLimits} />
    </>
  )
}

export default Form.create({})(AccountSettings)
